import React, { useEffect, useMemo, useState, useContext } from "react";
import { useHistory, Link } from "react-router-dom"; // v5
import "./css/PersonalFinance.css";
import { exportCourseDocx, openIosStagingTab } from "./utils/docxExport";
import { LanguageContext } from "./LanguageContext";
import "./css/InvestparaBr.css";

const apiUrl = "https://qedeefqyh2.execute-api.us-west-2.amazonaws.com/prod";

// ===== DEV BYPASS =====
//const isDev = process.env.NODE_ENV === "development";
const authEnabled = true; // disable auth checks on localhost/dev

// Curso 100% em PT — títulos escritos diretamente
const COURSE_PT = [
  {
    module: 0,
    moduleTitle: "Módulo 0 – Orientação",
    lessons: [
      { id: 1, title: "Bem-vindo(a) & como o curso funciona" },
      { id: 2, title: "Entendendo o Cenário de Investimentos nos EUA" },
    ],
  },
  {
    module: 1,
    moduleTitle: "Módulo 1 – Contas: Brokerage vs Aposentadoria",
    lessons: [
      { id: 1, title: "Conta brokerage (taxable) — prós/contras, quando usar" },
      { id: 2, title: "Visão geral de contas de aposentadoria" },
      { id: 3, title: "Elegibilidade (SSN vs ITIN), status de emprego, limites de contribuição, match do empregador" },
      { id: 4, title: "Rollovers (old 401k → IRA)" },
    ],
  },
  {
    module: 2,
    moduleTitle: "Módulo 2 – Impostos nos EUA para Investidores (Simplificado)",
    lessons: [
      { id: 1, title: "O que é tributado: ganhos de capital, dividendos, juros" },
      { id: 2, title: "Lotes, Custo de Aquisição e Tax-Loss Harvesting (Conceito)" },
      { id: 3, title: "Como as Contas de Aposentadoria Afetam os Impostos" },
      { id: 4, title: "Noções básicas de declaração de impostos para imigrantes" },
    ],
  },
  {
    module: 3,
    moduleTitle: "Módulo 3 – Instrumentos Principais: ETFs, REITs e Bonds",
    lessons: [
      { id: 1, title: "ETFs – Fundos de Índice que Facilitam seu Investimento" },
      { id: 2, title: "REITs – Fundos Imobiliários Americanos" },
      { id: 3, title: "Bonds na Prática" },
      { id: 4, title: "Montando portfólio “core & satellite”" },
    ],
  },
  {
    module: 4,
    moduleTitle: "Módulo 4 – Construção de Portfólio e Automação",
    lessons: [
      { id: 1, title: "Alocação de ativos por objetivo e prazo" },
      { id: 2, title: "Dollar-cost averaging, Investimento Automático e Rebalanceamento" },
      { id: 3, title: "Controles de risco" },
      { id: 4, title: "Planos de Aposentadoria: Target-Date Funds vs Build-Your-Own" },
    ],
  },
  {
    module: 5,
    moduleTitle: "Módulo 5 – Planos de Aposentadoria em Detalhe",
    lessons: [
      { id: 1, title: "401(k) – match, vesting, Roth 401(k), opções dentro do plano" },
      { id: 2, title: "IRAs – Traditional vs Roth, Backdoor Roth (conceitual), janelas de contribuição" },
      { id: 3, title: "Autônomos – Solo 401(k) & SEP IRA (visão geral)" },
    ],
  },
  {
    module: 6,
    moduleTitle: "Módulo 6 – Erros Comuns, Golpes e  Projeto Capstone",
    lessons: [
      { id: 1, title: "Erros comuns de brasileiros nos EUA" },
      { id: 2, title: "Scams & False Gurus" },
      { id: 3, title: "Cross-Border Basics" },
      { id: 4, title: "Capstone – Seu Plano de Investimento de 90 Dias" },
    ],
  },
];


const InvestParaBr = () => {
  const history = useHistory();
  const [downloading, setDownloading] = useState(false);
  const { language, toggleLanguage, translations } = useContext(LanguageContext);
  const [showIntro, setShowIntro] = useState(false);

  // Começa com Módulo 0 aberto
  const initialOpen = useMemo(() => {
    const obj = {};
    for (const m of COURSE_PT) obj[m.module] = m.module === 0;
    return obj;
  }, []);
  const [showModule, setShowModule] = useState(initialOpen);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  // Navegação direta (sem login), lang fixo em "pt"
    const handleLessonClick = (moduleNumber, lessonId) => {
    const course = "investindo-nos-eua"; // <-- your new course slug
    const lang = "pt";
    history.push(
      `/lessons/module${moduleNumber}/lesson${lessonId}?lang=${lang}&course=${course}&free=1`
    );
  };

  // Refs para exportar TODAS as aulas (multi-módulo)
  const buildRefs = () => {
    const refs = [];
    for (const entry of COURSE_PT) {
      for (const lesson of entry.lessons) {
        refs.push({
          moduleKey: `module${entry.module}`,
          lessonKey: `lesson${lesson.id}`,
          id: lesson.id,
        });
      }
    }
    // Ordena por módulo e id
    refs.sort((a, b) => {
      const am = parseInt(a.moduleKey.replace("module", ""), 10);
      const bm = parseInt(b.moduleKey.replace("module", ""), 10);
      if (am !== bm) return am - bm;
      return a.id - b.id;
    });
    return refs;
  };

  const handleDownload = async () => {
    const preWin = openIosStagingTab();
    try {
      setDownloading(true);
      const refs = buildRefs();
      await exportCourseDocx({
        refs,
        apiUrl,
        language: "pt",
        docTitle: "Investindo nos EUA para Brasileiros – PT",
        fileBase: "investpara-br-PT",
        labels: {
          courseIntro: "",           // opcional
          moduleLabel: "Módulo",
          showModuleHeadings: true,  // vários módulos
          renumberSingleModuleTo1: false,
        },
        preOpenedWin: preWin,
      });
    } catch (e) {
      console.error(e);
      alert("Desculpe — não foi possível criar o arquivo Word.");
      if (preWin) preWin.close();
    } finally {
      setDownloading(false);
    }
  };

  const courseIntroStyle = {
  maxWidth: "800px",
  margin: "0 auto 24px auto",
  fontSize: "1rem",
  lineHeight: 1.6,
};

const ctaBoxStyle = {
  maxWidth: "800px",
  margin: "8px auto 32px auto",
  padding: "16px 20px",
  borderRadius: 12,
  background: "linear-gradient(90deg, #fff4d5, #ffe7b8)",
  border: "1px solid #f2c97c",
  textAlign: "center",
};

const ctaButtonStyle = {
  display: "inline-block",
  marginTop: "10px",
  padding: "10px 20px",
  borderRadius: 999,
  backgroundColor: "#245580",
  color: "#ffffff",
  fontWeight: 700,
  textDecoration: "none",
  cursor: "pointer",
  fontSize: "0.95rem",
  letterSpacing: "0.04em",
  textTransform: "uppercase",
};


  return (
    <div className="investpara-page">
    <div className="courses-page1">
        {/* Everything on this page goes inside this container */}

        <h1 className="investpara-title">
          {language === "pt" ? (
            <>Investindo nos EUA para <span>Brasileiros</span></>
          ) : (
            <>Investing in the U.S. for <span>Brazilians</span></>
          )}
        </h1>

        {/* ===== INTRO CARD (SCOPED CONTAINER) ===== */}
<section className="investpara-introCard">
  
  <span className="course-badge course-badge--trial" style={{ marginBottom: 12 }}>
    {language === "pt" ? "Módulo 0 Grátis" : "Module 0 Free"}
  </span>
  <h2 className="investpara-subtitle">
    {language === "pt"
      ? "Invista nos EUA com Clareza, Segurança e Estratégia"
      : "Invest in the U.S. with Clarity, Security and Strategy"}
  </h2>

  <p className="investpara-lead">
    Um guia completo em português para brasileiros que querem investir nos EUA
    sem depender de consultores, gurus ou achismos.
  </p>

  {/* Collapsible content */}
  <div
    className={`investpara-collapsible ${showIntro ? "open" : "closed"}`}
    aria-hidden={!showIntro}
  >
    <p className="investpara-paragraph">
      {language === "pt"
        ? "Curso 100% em português, focado em brasileiros que querem investir nos EUA com segurança: contas (brokerage x aposentadoria), impostos básicos, ETFs/REITs/bonds, construção de portfólio e armadilhas comuns para imigrantes."
        : "100% Portuguese-language course, designed for Brazilians who want to invest safely in the U.S.: accounts (brokerage vs retirement), basic taxes, ETFs/REITs/bonds, portfolio construction, and common pitfalls for immigrants."}
    </p>

    <div className="investpara-block">
      <h3>Ao final do curso, você será capaz de:</h3>
      <ul>
        <li>Escolher corretamente entre conta brokerage e contas de aposentadoria</li>
        <li>Entender os impostos básicos e evitar erros comuns de brasileiros</li>
        <li>Investir em ETFs, REITs e bonds com estratégia de longo prazo</li>
        <li>Montar um portfólio alinhado aos seus objetivos e perfil de risco</li>
        <li>Criar um plano de investimento prático para os próximos 90 dias</li>
      </ul>
    </div>

    <div className="investpara-grid2">
      <div className="investpara-block">
        <h3>Este curso é para você se:</h3>
        <ul>
          <li>É brasileiro morando nos EUA ou planejando investir lá</li>
          <li>Quer investir com segurança e visão de longo prazo</li>
          <li>Se sente perdido com termos como IRA, ETF, taxes ou 401(k)</li>
        </ul>
      </div>

      <div className="investpara-block">
        <h3>Este curso NÃO é para você se:</h3>
        <ul>
          <li>Procura day trade ou ganhos rápidos</li>
          <li>Quer dicas de ações específicas</li>
          <li>Não quer estudar ou montar seu próprio plano</li>
        </ul>
      </div>
    </div>

    <div className="investpara-block">
  <h3>O que está incluso no curso</h3>

  <p style={{ margin: "6px 0 12px 0", opacity: 0.9 }}>
    <strong>+24 vídeo-aulas</strong> • <strong>Duração total:</strong> ~1h 14min •
    <strong> Idioma:</strong> Português
  </p>

  <ul>
    <li>Conteúdo prático e estruturado por módulos</li>
    <li>Projeto Capstone: Plano de Investimento de 90 dias</li>
    <li>Materiais de apoio para download</li>
    <li>Acesso vitalício ao conteúdo</li>
  </ul>
</div>

<div style={{ marginTop: 14 }}>
    <Link
      to="/payment-investindo-nos-eua"
      className="investpara-ctaBtn"
    >
      Comprar o curso
    </Link>

    <div className="investpara-ctaSubtext">
      Compra sem risco: se não fizer sentido para você, devolvemos seu dinheiro.
    </div>
  </div>

    <div className="investpara-block">
      <h3>Perguntas frequentes</h3>

      <p><strong>Preciso morar nos EUA?</strong><br />
      Não, mas o conteúdo é focado em quem investe ou pretende investir nos EUA.</p>

      <p><strong>Funciona para iniciantes?</strong><br />
      Sim. O curso começa do zero e evolui passo a passo.</p>

      <p><strong>O curso indica ações específicas?</strong><br />
      Não. O foco é estratégia, estrutura e autonomia.</p>

      <p><strong>Isso substitui um contador ou advisor?</strong><br />
      Não. O curso é educacional e não oferece recomendação individual.</p>
    </div>
  </div>

  {/* Show more/less button */}
  <button
    type="button"
    className="investpara-toggleLink"
    onClick={() => setShowIntro((v) => !v)}
    aria-expanded={showIntro}
  >
    {showIntro
      ? (language === "pt" ? "Ver menos ↑" : "Show less ↑")
      : (language === "pt" ? "Ver mais sobre o curso ↓" : "Show more about the course ↓")}
  </button>
</section>

    {/* CTA de Black Friday */}
{/*<div style={ctaBoxStyle}>
  <p style={{ margin: 0 }}>
    {language === "pt" ? (
      <>
        Preço especial de <strong>Black Friday</strong>:{" "}
      </>
    ) : (
      <>
        Special <strong>Black Friday</strong> price:{" "}
      </>
    )}
  </p>

  <Link to="/payment-investindo-nos-eua" style={ctaButtonStyle}>
    {language === "pt"
      ? "Garantir acesso por US$ 19,99"
      : "Get access for US$ 19.99"}
  </Link>
</div>*/}

        {/* ===== MODULES ===== */}
        {COURSE_PT.map((entry) => {
          const open = !!showModule[entry.module];
          const toggle = () =>
            setShowModule((s) => ({ ...s, [entry.module]: !s[entry.module] }));

          return (
            <div className="pf-module module" key={entry.module}>
              <h2
                onClick={toggle}
                className="toggle-heading"
                role="button"
                aria-expanded={open}
                tabIndex={0}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && toggle()}
              >
                {entry.moduleTitle}
                <span className={`arrow ${open ? "open" : ""}`}>&gt;</span>
              </h2>

              {open && (
                <ul>
                  {entry.lessons
                    .slice()
                    .sort((a, b) => a.id - b.id)
                    .map((lesson, idx) => (
                      <li key={`${entry.module}-${lesson.id}`} className="lesson-row">
                        <button
                          onClick={() => handleLessonClick(entry.module, lesson.id)}
                          className="lesson-link1"
                        >
                          {idx + 1}. {lesson.title}
                        </button>
                      </li>
                    ))}
                </ul>
              )}
            </div>
          );
        })}


      {/* ===== DOWNLOAD ===== */}
      <h3>Baixar conteúdo (disponível ao final do curso)</h3>

      <button
        type="button"
        disabled
        className="lesson-link"
        style={{
          padding: "8px 14px",
          borderRadius: 8,
          opacity: 0.6,
          cursor: "not-allowed",
        }}
      >
        Conteúdo disponível para download ao final do curso
      </button>
      
    </div>
  </div>
  );
};

export default InvestParaBr;

